let dashboard_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    meta: {isPublicRoute: false},
    children: [
      // { path: '', name: "dashboard", component: () => import('Modules/Dashboard/resources/pages/Index.vue') }
      { path: '', name: "dashboard", redirect: {name: 'send-money'} }
    ]
  }
];

export default dashboard_routes;
